

export class Cliente {
    n?:string;
    idcliente?:string;
    nombre?:string;
    apellidos?:string;
    nombrecompleto?:string;
    ruc?:string;
    dni?:string;
    documento?:string;
    tipodocumento?:any;
    tipodocide?:string;
    direccion?:string;
    email?:string;
    telefono?:string;
    zona_ubigeo?:string;
    tipo_balon?:any;
    tipo_balon_str?:any;
    link_maps?:string;
    tipo_cliente?:string;
    constructor(){}
}
